import React,{useState} from 'react';
import './UtilityPanel.css';
import InfoCard from './components/InfoCard';
import Trepuntini from '../../importfiles/3puntini.png';
import Arrow from '../../importfiles/arrow.png';
import { StepIcon } from '../Icons/StepIcons';
const UtilityPanel = ({ steps, uploadedFiles, onStepClick }) => {
    const [mobileOpen, setMobileOpen] = useState(false);
    const [activeTab, setActiveTab] = useState('steps'); // 'steps' | 'files'

    const visibleSteps = steps.filter(step => step.active || step.completed);

    const panelContent = (
        <>
            {/* Tabs per scegliere Steps o Files */}
            <div className="utility-tabs">
                <button
                    className={`utility-tab ${activeTab === 'steps' ? 'utility-tab-active' : ''}`}
                    onClick={() => setActiveTab('steps')}
                >
                    Steps
                </button>
                <button
                    className={`utility-tab ${activeTab === 'files' ? 'utility-tab-active' : ''}`}
                    onClick={() => setActiveTab('files')}
                >
                    Files
                </button>
            </div>

            {activeTab === 'steps' && (
                <InfoCard title="Steps">
                       <div className="sidebar-divider2"></div>
                    <div className="steps-list">
                        {visibleSteps.map((step, index) => (
                            <div
                                key={`${step.key || 'step'}-${index}`}
                                onClick={() => { onStepClick && onStepClick(step.key); setMobileOpen(false); }}
                                className={`step-item ${step.active ? 'active-step' : ''}`}
                            >
                                <span className={`step-dot ${step.active ? 'active-dot' : ''}`}>
                                    {step.completed ? '✓' : ''}
                                </span>
                                {/* {step.icon && (
                                    <img src={step.icon} alt={step.label} className="step-icon-img" />
                                )} */}
                                <StepIcon stepKey={step.key} />
                                {step.label}
                            </div>
                        ))}
                    </div>
                </InfoCard>
            )}

            {activeTab === 'files' && (
                <div className="utility-card">
                    <h3 className="utility-card-title">Uploaded files</h3>
                       <div className="sidebar-divider2"></div>
                    <div className="uploaded-files-list">
                        {uploadedFiles.map((file, index) => (
                            <div key={index} className="file-item-row">
                                <span className="file-bullet">📄</span>
                                <span className="file-name">{file.name}</span>
                                <span className={`file-status file-status-${(file.status || 'analyzed').toLowerCase()}`}>
                                    {file.status === 'Processing'
                                        ? <span className="file-status-spinner" aria-label="Loading" />
                                        : file.status === 'Error'
                                            ? '⚠️'
                                            : '✓'}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </>
    );

        const getFileIconName = (fileName) => {
    if (!fileName) return "insert_drive_file"; 
    
    // Prende l'estensione (es. "pdf" da "documento.pdf")
    const ext = fileName.split('.').pop().toLowerCase();
    
    switch (ext) {
        case 'pdf': return "picture_as_pdf";
        case 'xls': 
        case 'xlsx': 
        case 'csv': return "table_view";
        case 'doc': 
        case 'docx': return "description";
        case 'jpg': 
        case 'jpeg': 
        case 'png': 
        case 'svg': return "image";
        case 'zip': 
        case 'rar': return "folder_zip";
        case 'txt': return "article";
        case 'json': return "file_json";

        default: return "insert_drive_file"; // Icona di default per file generici
    }
};


    return (
        <>
            {/* Burger button — solo su mobile, in alto a destra */}
            <button
                className="utility-hamburger"
                onClick={() => setMobileOpen(true)}
                aria-label="Apri pannello"
            >
                <img src={Trepuntini} alt="Menu" style={{ width: '35px', height: '35px' }} />
            </button>

            {/* Overlay */}
            {mobileOpen && (
                <div
                    className="utility-overlay"
                    onClick={() => setMobileOpen(false)}
                />
            )}

            {/* Drawer da destra su mobile / pannello normale su desktop */}
            <div className={`app-utility-panel ${mobileOpen ? 'utility-panel-open' : ''}`}>

                {/* Bottone chiudi — solo mobile */}
                <button
                    className="utility-close"
                    onClick={() => setMobileOpen(false)}
                    aria-label="Chiudi pannello"
                >
                    <img src={Arrow} alt="Close" style={{ width: '20px', height: '20px' }} />
                </button>

                {/* Su mobile mostra tabs, su desktop mostra tutto */}
                <div className="utility-desktop-content">
                    <InfoCard title="Steps">
                        <div className="steps-list">
                            {visibleSteps.map((step, index) => (
                                <div
                                    key={step.key || index}
                                    onClick={() => onStepClick && onStepClick(step.key)}
                                    className={`step-item ${step.active ? 'active-step' : ''}`}
                                >
                                    <span className={`step-dot ${step.active ? 'active-dot' : ''}`}>
                                        {step.completed ? '✓' : ''}
                                    </span>
                                    {/* {step.icon && (
                                        <img src={step.icon} alt={step.label} className="step-icon-img" />
                                    )} */}
                                    <StepIcon stepKey={step.key} />
                                    {step.label}
                                </div>
                            ))}
                        </div>
                    </InfoCard>

                    <div className="utility-card">
                        <h3 className="utility-card-title">Uploaded files</h3>
                           <div className="sidebar-divider2"></div>
                        <div className="uploaded-files-list">
                            {uploadedFiles.map((file, index) => (
                                <div key={file.id || `${file.name}-${index}`} className="file-item-row">
                                    <span 
                                        className="material-symbols-outlined file-bullet" 
                                        style={{ 
                                            color: '#C17F52;', 
                                            fontSize: '18px', 
                                            marginRight: '8px' 
                                        }}
                                    >
                                        {getFileIconName(file.name)}
                                    </span>
                                    <span className="file-name">{file.name}</span>
                                    <span className={`file-status file-status-${(file.status || 'analyzed').toLowerCase()}`}>
                                        {file.status === 'Processing'
                                            ? <span className="file-status-spinner" aria-label="Loading" />
                                            : file.status === 'Error'
                                                ? '⚠️'
                                                : '✓'}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Solo mobile: tabs */}
                <div className="utility-mobile-content">
                    {panelContent}
                </div>
            </div>
        </>
    );
};

export default UtilityPanel;